import React from "react";
import {
  AffectedIcon,
  AffectedReportsIcon,
  AffectedRptIcon,
  AgencyManagement,
  AnimalShelterIconReport,
  Awareness,
  ColdWaveDashboard,
  CommunityKitchen,
  CommunityKitchenIcon,
  ConfigurationManagement,
  ConsolidatedIcon,
  ConsolidatedReportsIcon,
  ConsolidatedRptIcon,
  ContactManagement,
  DailyFloodIcons,
  DailyReportsIcon,
  DashboardIcon,
  DashboardIconNew,
  DevicesIcon,
  EventsIcon,
  Execution,
  FacilityManagement,
  FireDashboard,
  FloodDashboardIcon,
  FloodRelief,
  GisManagement,
  HeatWaveDashboard,
  Home,
  HumanLoss,
  IncidentDashboard,
  IncidentFacility,
  MapIcon,
  MasterResourceManagement,
  MisReportsIcon,
  MyTaskList,
  MyTasks,
  PartiallyAffectedIcons,
  PartiallyAffectedRptIcon,
  PartiallyAfftdIcons,
  PolicesIcon,
  RegionManagement,
  Relief,
  ReportsIcon,
  ReportStatusIcon,
  ReportStsIcon,
  ResourceManagement,
  Resources,
  ResourcesIcons,
  RolesIcons,
  SopManagement,
  StateFloodIcons,
  TaskManagement,
  TaskManagementIcon,
  TasksList,
  TasksSopIcons,
  UserRoleManagement,
  UserRoleManagementIcon,
  UsersIcon,
  UsersIcons,
  HelpdeskGrievancesIconConv,
  HeavyRain,
  Avalanche,
  Waterfall,
  EarhquakeIcon,
  MessageIcon,
} from "../Components/IconComponents";
import SvgIncidentDashboard from "../Components/IconComponents/IncidentDashboard";
import { Bot, Disc, EarthIcon, Mountain, MountainSnow, PanelBottomDashed, PlaneLanding, Siren, FilePlus2, Radio } from "lucide-react";
import CloudburstDashboard from "../Pages/DMS/Dashboard/CloudBrust/CloudBrustDashboard";
import { FaMountain } from "react-icons/fa";
import SvgMountain from "../Components/IconComponents/Mountain";
import SvgAvalanche from "../Components/IconComponents/Avalanche";
import SvgThunderstorm from "../Components/IconComponents/Thunderstorm";

const height = "1.2em";
const width = "1.2em";

const navLinks = [
  // ─────────────────────────────────────────
  // 1. OPERATIONAL DASHBOARD
  // ─────────────────────────────────────────
  {
    to: "main-dashboard",
    icon: <DashboardIconNew width={"1.5em"} height={"1.5em"} />,
    label: "Operational Dashboard",
    allowedPermissionIds: [64],
    children: [],
  },

  // ─────────────────────────────────────────
  // 2. PRE-DISASTER & EARLY WARNING
  // ─────────────────────────────────────────
  {
    to: "Disaster-acknowledgereport",
    icon: <Siren width={"1.6em"} height={"1.6em"} />,
    label: "Pre Disaster & Early Warning",
    allowedPermissionIds: [95],
    children: [
      {
        to: "create-alert",
        icon: <FilePlus2 width={width} height={height} />,
        label: "Stimulate Alert",
        allowedPermissionIds: [100],
        children: [],
      },
      // {
      //   to: "cap-alerts",
      //   icon: <Radio width={width} height={height} />,
      //   label: "NDMA Alerts",
      //   allowedPermissionIds: [101],
      //   children: [],
      // },
      {
        to: "",  // This is the index route for Pre Disaster Alert Report
        icon: <Siren width={width} height={height} />,
        label: "Pre Disaster Alert Report",
        allowedPermissionIds: [83],
        children: [],
      },
      {
        to: "situation-awareness",
        icon: <Awareness width={width} height={height} />,
        label: "Situational Awareness (GIS)",
        allowedPermissionIds: [27],
        children: [
          {
            to: "incident-management",
            icon: <SvgIncidentDashboard width={width} height={height} />,
            label: "Incident Management",
            allowedPermissionIds: [29],
            children: [],
          },
          {
            to: "map-view",
            icon: <MapIcon width={width} height={height} />,
            label: "Map View (GIS)",
            allowedPermissionIds: [28],
            children: [],
          },
        ],
      },
      {
        to: "view-sop",
        icon: <SopManagement width={width} height={height} />,
        label: "SOP Management",
        allowedPermissionIds: [36],
        children: [
          {
            to: "category-matrix",
            icon: <TasksSopIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.categorymatrix",
            children: [],
          },
          {
            to: "",  // Index for SOP list
            icon: <TasksSopIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.SOPlist",
            children: [],
          },
          {
            to: "view-task",
            icon: <TasksSopIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.task",
            children: [],
          },
          {
            to: "create-sop",
            icon: <ResourcesIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.SOP",
            children: [],
          },
          {
            to: "execute-sops",
            icon: <TasksSopIcons width={width} height={height} />,
            label: "navlinklabels.execute-sops",
            children: [],
          },
          {
            to: "Sop-instance-list",
            icon: <TasksSopIcons width={width} height={height} />,
            label: "navlinklabels.sopinstancelist",
            children: [],
          },
        ],
      },
      {
        to: "resource-assign-list",  // This is the parent path for Response & Relief
        icon: <Relief width={width} height={height} />,
        label: "Response & Relief",
        allowedPermissionIds: [31],
        children: [
          {
            to: "deployment-resource",  // Child route
            icon: <TasksSopIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.resourcedeploymentresource",
            allowedPermissionIds: [82],
            children: [],
          },
          {
            to: "",  // Index route for Resource Allocation List
            icon: <UsersIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.resourceallocationlist",
            allowedPermissionIds: [81],
            children: [],
          },
        ],
      },
      {
        to: "Active-panellist",
        icon: <PanelBottomDashed width={width} height={height} />,
        label: "Resource Activity Panel",
        allowedPermissionIds: [84],
        children: [],
      },
      {
        to: "my-tasks",  // This is the parent path for Task Management
        icon: <MyTasks width={width} height={height} />,
        label: "Task Management",
        allowedPermissionIds: [79],
        children: [
          {
            to: "",  // Index route for Task List
            icon: <MyTaskList width={width} height={height} />,
            label: "Task List",
            allowedPermissionIds: [80],
            children: [],
          },
          {
            to: "view-usertask",  // Child route
            icon: <TaskManagementIcon width={width} height={height} />,
            label: "Daily Operational Task",
            allowedPermissionIds: [40],
            children: [],
          },
        ],
      },
    ],
  },

  // ─────────────────────────────────────────
  // 3. POST-DISASTER ANALYSIS
  // ─────────────────────────────────────────
  {
    to: "post-disaster-analysis",
    icon: <FloodDashboardIcon width={"1.5em"} height={"1.5em"} />,
    label: "Post Disaster Analysis",
    allowedPermissionIds: [96],
    children: [
      {
        to: "dist-dashboard",
        icon: <FloodDashboardIcon width={width} height={height} />,
        label: "Flood Dashboard",
        allowedPermissionIds: [56],
        children: [],
      },
      {
        to: "Earthquake-dashboard",
        icon: <EarhquakeIcon width={"1.5em"} height={"1.5em"} />,
        label: "Earthquake Dashboard",
        allowedPermissionIds: [85],
        children: [],
      },
      {
        to: "cloudbrust-dashboard",
        icon: <SvgThunderstorm width={width} height={height} />,
        label: "Cloud Burst Dashboard",
        allowedPermissionIds: [86],
        children: [],
      },
      {
        to: "Avalanche-dashboard",
        icon: <MountainSnow width={width} height={height} />,
        label: "Avalanche Dashboard",
        allowedPermissionIds: [87],
        children: [],
      },
      {
        to: "Glof-dashboard",
        icon: <SvgMountain width={width} height={height} />,
        label: "GLOF Dashboard",
        allowedPermissionIds: [88],
        children: [],
      },
      {
        to: "coldwave-dashboard",
        icon: <ColdWaveDashboard width={width} height={height} />,
        label: "Cold Wave Dashboard",
        allowedPermissionIds: [58],
        children: [],
      },
      {
        to: "humanloss-dashboard",
        icon: <HumanLoss width={"2.2em"} height={"2.2em"} />,
        label: "Human Loss - Primary Information Dashboard",
        allowedPermissionIds: [57],
        children: [],
      },
      {
        to: "fire-dashboard",
        icon: <FireDashboard width={width} height={height} />,
        label: "Fire Incident Dashboard",
        allowedPermissionIds: [59],
        children: [],
      },
      {
        to: "heatwave-dashboard",
        icon: <HeatWaveDashboard width={width} height={height} />,
        label: "Heat Wave Dashboard",
        allowedPermissionIds: [60],
        children: [],
      },
      {
        to: "dmsdashboard",
        icon: <IncidentFacility width={"1.5em"} height={"1.5em"} />,
        label: "navlinklabels.incidentdashboard",
        allowedPermissionIds: [67],
        children: [],
      },
      {
        to: "incidentdashboard",
        icon: <IncidentDashboard width={width} height={height} />,
        label: "Incident Dashboard",
        allowedPermissionIds: [68],
        children: [],
      },
    ],
  },
  {
    to: "reports",
    icon: <ReportsIcon width={"1.6em"} height={"1.6em"} />,
    label: "Report",
    allowedPermissionIds: [69],
    children: [
      {
        to: "affected-floodreport",
        icon: <FloodDashboardIcon width={width} height={height} />,
        label: "Flood Reports",
        allowedPermissionIds: [70],
        children: [
          {
            to: "../affected-floodreport",
            label: "navlinklabels.dailyreport",
            icon: <DailyFloodIcons width={width} height={height} />,
            children: [
              {
                to: "../affected-floodreport",
                icon: <DailyReportsIcon width={"1.5em"} height={"1.5em"} />,
                label: "Form 1 - Daily Report",
                children: [],
              },
              {
                to: "../partiallyaffected-floodreport",
                icon: <PartiallyAffectedRptIcon width={"1.7em"} height={"1.7em"} />,
                label: "Partially Affected Report",
                children: [],
              },
              {
                to: "../dailyfloodreport",
                icon: <ConsolidatedRptIcon width={"1.7em"} height={"1.7em"} />,
                label: "Flood Report Consolidated",
                children: [],
              },
              {
                to: "../reporting-status",
                icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
                label: "Form 1 - Reporting Status",
                children: [],
              },
            ],
          },
          {
            to: "../affected-report",
            label: "State Flood Report",
            icon: <StateFloodIcons width={width} height={height} />,
            children: [
              {
                to: "",
                icon: <AffectedRptIcon width={width} height={height} />,
                label: "Affected Report",
                children: [],
              },
              {
                to: "../partiallyaffected-report",
                icon: <PartiallyAffectedRptIcon width={"1.7em"} height={"1.7em"} />,
                label: "Partially Affected Report",
                children: [],
              },
              {
                to: "../statefloodreport",
                icon: <ConsolidatedRptIcon width={"1.5em"} height={"1.5em"} />,
                label: "Consolidated Report",
                children: [],
              },
            ],
          },
          {
            to: "../misdist-report",
            icon: <MisReportsIcon width={width} height={height} />,
            label: "MIS Flood Report",
            children: [],
          },
        ],
      },
      {
        to: "cloud-burst-report",
        icon: <SvgThunderstorm width={width} height={height} />,
        label: "Cloud Burst Reports",
        allowedPermissionIds: [90],
        children: [
          {
            to: "../cloud-burst-report",
            icon: <DailyReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Cloud Burst - Daily Report",
            children: [],
          },
          {
            to: "../cloud-burst-misreport",
            icon: <MisReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Cloud Burst - MIS Report",
            children: [],
          },
          {
            to: "../cloud-burst-reporting-status",
            icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
            label: "Cloud Burst Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "avalancheincident-report",
        icon: <MountainSnow width={width} height={height} />,
        label: "Avalanche Reports",
        allowedPermissionIds: [91],
        children: [
          {
            to: "../avalancheincident-report",
            icon: <DailyReportsIcon width={"2.0em"} height={"2.0em"} />,
            label: "Avalanche - Daily Report Form",
            children: [],
          },
          {
            to: "../mis-avalanche-report",
            icon: <MisReportsIcon width={width} height={height} />,
            label: "Avalanche - MIS Report",
            children: [],
          },
          {
            to: "../avalanche-wave-reporting-status",
            icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
            label: "Avalanche Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "glofincident-report",
        icon: <SvgMountain width={width} height={height} />,
        label: "GLOF Reports",
        allowedPermissionIds: [92],
        children: [
          {
            to: "../glofincident-report",
            icon: <DailyReportsIcon width={"1.3em"} height={"1.3em"} />,
            label: "GLOF - Daily Report Form",
            children: [],
          },
          {
            to: "../mis-glof-report",
            icon: <MisReportsIcon width={"1.2em"} height={"1.2em"} />,
            label: "GLOF - MIS Report",
            children: [],
          },
          {
            to: "../glof-reporting-status",
            icon: <ReportStatusIcon width={"1.3em"} height={"1.3em"} />,
            label: "GLOF Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "earthquakeincident-report",
        icon: <EarhquakeIcon width={"1.5em"} height={"1.5em"} />,
        label: "Earthquake Reports",
        allowedPermissionIds: [89],
        children: [
          {
            to: "../earthquakeincident-report",
            icon: <DailyReportsIcon width={"1.3em"} height={"1.3em"} />,
            label: "Earthquake - Daily Report Form",
            children: [],
          },
          {
            to: "../mis-earthquake-report",
            icon: <MisReportsIcon width={"1.2em"} height={"1.2em"} />,
            label: "Earthquake - MIS Report",
            children: [],
          },
          {
            to: "../earthquake-reporting-status",
            icon: <ReportStatusIcon width={"1.3em"} height={"1.3em"} />,
            label: "Earthquake Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "dr-cold-wave",
        icon: <ColdWaveDashboard width={width} height={height} />,
        label: "Cold Wave Reports",
        allowedPermissionIds: [74],
        children: [
          {
            to: "../dr-cold-wave",
            icon: <DailyReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Cold Wave - Daily Report",
            children: [],
          },
          {
            to: "../misdist-coldwave-report",
            icon: <MisReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Cold Wave - MIS Report",
            children: [],
          },
          {
            to: "../cold-wave-reporting-status",
            icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
            label: "Cold Wave Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "human-loss-report",
        icon: <HumanLoss width={width} height={height} />,
        label: "Human Loss Reports",
        allowedPermissionIds: [71],
        children: [
          {
            to: "../human-loss-report",
            icon: <DailyReportsIcon width={"3.0em"} height={"3.0em"} />,
            label: "Human Loss - Primary And Detailed Information Report",
            children: [],
          },
          {
            to: "../mis-human-loss-report",
            icon: <MisReportsIcon width={"1.5em"} height={"1.5em"} />,
            label: "Human Loss - MIS Report",
            children: [],
          },
        ],
      },
      {
        to: "fireincident-report",
        icon: <FireDashboard width={width} height={height} />,
        label: "Fire Reports",
        allowedPermissionIds: [72],
        children: [
          {
            to: "../fireincident-report",
            icon: <DailyReportsIcon width={"2.0em"} height={"2.0em"} />,
            label: "Fire Incident - Daily Report Form",
            children: [],
          },
          {
            to: "../mis-fire-report",
            icon: <MisReportsIcon width={width} height={height} />,
            label: "Fire - MIS Report",
            children: [],
          },
          {
            to: "../fire-community-kitchen-report",
            icon: <CommunityKitchen width={"2.0em"} height={"2.0em"} />,
            label: "Fire - Community kitchen Daily Report",
            children: [],
          },
          {
            to: "../fire-wave-reporting-status",
            icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
            label: "Fire Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "heat-wave-report",
        icon: <HeatWaveDashboard width={width} height={height} />,
        label: "Heat Wave Reports",
        allowedPermissionIds: [73],
        children: [
          {
            to: "../heat-wave-report",
            icon: <DailyReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Heat Wave - Daily Report",
            children: [],
          },
          {
            to: "../heat-wave-misreport",
            icon: <MisReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Heat Wave - MIS Report",
            children: [],
          },
          {
            to: "../heat-wave-reporting-status",
            icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
            label: "Heat Wave Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "community-kitchen",
        icon: <IncidentFacility width={"1.5em"} height={"1.5em"} />,
        label: "Incident Facilities Reports",
        allowedPermissionIds: [75],
        children: [
          {
            to: "../community-kitchen",
            icon: <CommunityKitchenIcon width={"1.5em"} height={"1.5em"} />,
            label: "navlinklabels.communitykitchen",
            children: [],
          },
          {
            to: "../fl-camp",
            icon: <FloodRelief width={"1.7em"} height={"1.7em"} />,
            label: "navlinklabels.floodcamp",
            children: [],
          },
          {
            to: "../animal-shelter",
            icon: <AnimalShelterIconReport width={"1.5em"} height={"1.5em"} />,
            label: "navlinklabels.animalshelter",
            children: [],
          },
        ],
      },
    ],
  },

  // ─────────────────────────────────────────
  // 5. PLANNING & ADMINISTRATION
  // ─────────────────────────────────────────
  {
    to: "planning",
    icon: <DevicesIcon width={"1.6em"} height={"1.6em"} />,
    label: "Administration & Planning",
    allowedPermissionIds: [26],
    children: [
      {
        to: "masterdata-table",
        icon: <ConfigurationManagement width={"1.5em"} height={"1.5em"} />,
        label: "navlinklabels.configmgmnt",
        allowedPermissionIds: [2],
        children: [],
      },
      {
        to: "region-list",
        icon: <RegionManagement width={width} height={height} />,
        label: "navlinklabels.regionmgmnt",
        allowedPermissionIds: [6],
        children: [],
      },
      {
        to: "agency-list",
        icon: <AgencyManagement width={width} height={height} />,
        label: "navlinklabels.agencymgmnt",
        allowedPermissionIds: [10],
        children: [],
      },
      {
        to: "users",  // Parent path for User Role Management
        icon: <UserRoleManagementIcon width={width} height={height} />,
        label: "navlinklabels.userrolemgmnt",
        allowedRoles: ["manage-users"],
        allowedPermissionIds: [37],
        children: [
          {
            to: "",  // Index route for Users list
            icon: <UsersIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.users",
            children: [],
          },
          {
            to: "roles",  // Child route for Roles
            icon: <RolesIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.roles",
            children: [],
          },
        ],
      },
      {
        to: "master-resource",
        icon: <MasterResourceManagement width={width} height={height} />,
        label: "navlinklabels.masterresource",
        allowedPermissionIds: [18],
        children: [],
      },
      {
        to: "user-activity",
        icon: <UserRoleManagement width={"1.5em"} height={"1.5em"} />,
        label: "navlinklabels.useractivity",
        allowedPermissionIds: [93],
        children: [],
      },
      {
        to: "view-contact",
        icon: <ContactManagement width={width} height={height} />,
        label: "navlinklabels.contactmgmnt",
        allowedPermissionIds: [22],
        children: [],
      },
      {
        to: "facility-mgmt",
        icon: <FacilityManagement width={width} height={height} />,
        label: "navlinklabels.facilitymgmnt",
        allowedPermissionIds: [34],
        children: [],
      },
      {
        to: "resource-list",
        icon: <Resources width={width} height={height} />,
        label: "navlinklabels.resourcemgmnt",
        allowedPermissionIds: [35],
        children: [],
      },
    ],
  },
  {
    to: "grievance",
    icon: <MessageIcon width={width} height={height} />,
    label: "Helpdesk/ Grievances",
     allowedPermissionIds: [97], // User does NOT have this permission ❌ - HIDDEN
    children: [
      {
        to: "raise-ticket",
        label: "Raise Ticket",
         allowedPermissionIds: [99],
        children: [],
      },
      {
        to: "grievance",
        label: "My Tickets",
         allowedPermissionIds: [98],
        children: [],
      },
      // {
      //   to: "manage-sla",
      //   label: "Manage SLA",
      //   // allowedPermissionIds: [83],
      //   children: [],
      // },
      // {
      //   to: "audit-history",
      //   label: "Audit History",
      //   // allowedPermissionIds: [90],
      //   children: [],
      // },
    ],
  },
];

export default navLinks;